import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import logoIcon from '../components/assets/icon.png';
import Footer from '../components/Footer';
import EnquiryModal from '../components/EnquiryModal';
import '../App.css';

const MusicProduction = () => {
  const [isEnquiryOpen, setIsEnquiryOpen] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const handleMenuClick = () => {
    setIsMenuOpen(false);
    setIsDropdownOpen(false);
    document.body.style.overflow = 'unset';
  };

  const toggleDropdown = (e) => {
    e.preventDefault();
    setIsDropdownOpen(!isDropdownOpen);
  };

  return (
    <div className="service-page">
      {/* Header */}
      <nav className="navbar scrolled">
        <div className="container nav-content">
          <Link to="/" className="logo">
            <img src={logoIcon} alt="Magic Moon Studios" className="logo-icon-img" />
            <span className="logo-text">MAGIC MOON STUDIOS</span>
          </Link>

          <button 
            className="mobile-menu-btn" 
            onClick={(e) => {
              e.stopPropagation();
              setIsMenuOpen(!isMenuOpen);
              setIsDropdownOpen(false);
              document.body.style.overflow = isMenuOpen ? 'unset' : 'hidden';
            }}
          >
            {isMenuOpen ? '✕' : '☰'}
          </button>

          {isMenuOpen && (
            <div 
              className="mobile-menu-backdrop" 
              onClick={(e) => {
                e.stopPropagation();
                setIsMenuOpen(false);
                setIsDropdownOpen(false);
                document.body.style.overflow = 'unset';
              }}
            />
          )}

          <ul className={`nav-links ${isMenuOpen ? 'active' : ''}`}>
            <li><Link to="/" onClick={handleMenuClick}>Home</Link></li>
            <li><a href="/#about" onClick={handleMenuClick}>About</a></li>
            <li><a href="/#projects" onClick={handleMenuClick}>Projects</a></li>
            <li className={`dropdown ${isDropdownOpen ? 'active' : ''}`}>
              <a href="#services" onClick={toggleDropdown}>Services ▾</a>
              <ul className="dropdown-menu">
                <li><Link to="/film-production" onClick={handleMenuClick}>Film Production</Link></li>
                <li><Link to="/short-movies" onClick={handleMenuClick}>Short Movies</Link></li>
                <li><Link to="/academy" onClick={handleMenuClick}>Academy</Link></li>
                <li><Link to="/ads-making" onClick={handleMenuClick}>Ads Making</Link></li>
                <li><Link to="/digital-content" onClick={handleMenuClick}>Digital Content</Link></li>
                <li><Link to="/music-production" onClick={handleMenuClick}>Music Production</Link></li>
              </ul>
            </li>
            <li><a href="/#team" onClick={handleMenuClick}>Team</a></li>
            <li><a href="/#contact" className="contact-btn" onClick={handleMenuClick}>Contact</a></li>
          </ul>
        </div>
      </nav>

      {/* Hero Section */}
      <section className="service-hero" style={{ 
        background: 'linear-gradient(rgba(15, 52, 96, 0.85), rgba(26, 26, 46, 0.85)), url("https://images.unsplash.com/photo-1598488035139-bdbb2231ce04?q=80&w=2000&auto=format&fit=crop")',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundAttachment: 'fixed'
      }}>
        <div className="container">
          <div className="service-hero-content">
            <h1 className="service-hero-title">Music Production</h1>
            <p className="service-hero-subtitle">
              Original scores, soundtracks, and audio post-production
            </p>
          </div>
        </div>
      </section>

      {/* Overview Section */}
      <section className="service-overview">
        <div className="container">
          <div className="overview-grid">
            <div className="overview-content">
              <h2 style={{ color: '#5B9BD5', marginBottom: '20px' }}>Professional Audio Excellence</h2>
              <p style={{ lineHeight: '1.8', marginBottom: '20px' }}>
                Magic Moon Studios delivers world-class music production and audio post-production services. 
                Our experienced composers, sound designers, and audio engineers create original scores, soundtracks, 
                and immersive sonic experiences that elevate your visual content to new heights.
              </p>
              <p style={{ lineHeight: '1.8', marginBottom: '20px' }}>
                From orchestral film scores to contemporary background music, we compose custom music tailored to your 
                project's emotional tone and narrative arc. Our state-of-the-art recording studio and mixing facilities 
                ensure pristine audio quality that meets international broadcast and cinema standards.
              </p>
              <p style={{ lineHeight: '1.8', marginBottom: '20px' }}>
                We handle complete audio post-production including sound design, Foley recording, dialogue editing, 
                ADR (Automated Dialogue Replacement), mixing, and mastering. Our team creates layered soundscapes 
                that enhance storytelling and provide audiences with an immersive auditory experience.
              </p>
            </div>
            <div className="overview-image">
              <img 
                src="https://images.unsplash.com/photo-1519508234439-4f23643125c1?q=80&w=800&auto=format&fit=crop" 
                alt="Music Production Studio"
                style={{ 
                  width: '100%', 
                  height: '400px', 
                  objectFit: 'cover',
                  borderRadius: '15px',
                  border: '3px solid #B8860B',
                  boxShadow: '0 10px 30px rgba(184, 134, 11, 0.3)'
                }}
              />
            </div>
          </div>
        </div>
      </section>

      {/* Services We Offer */}
      <section className="service-offerings" style={{ background: 'linear-gradient(to bottom, #F0F9FF 0%, #E3F2FD 100%)', padding: '80px 0' }}>
        <div className="container">
          <h2 style={{ textAlign: 'center', color: '#5B9BD5', marginBottom: '50px', fontSize: '2.5rem' }}>What We Offer</h2>
          <div className="offerings-grid" style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: '30px' }}>
            {[
              { 
                title: 'Film Scores', 
                desc: 'Original orchestral and contemporary music composition that enhances emotional impact and supports narrative storytelling', 
                icon: '🎼' 
              },
              { 
                title: 'Background Music', 
                desc: 'Custom background tracks for commercials, documentaries, corporate videos, and digital content in any genre or style', 
                icon: '🎹' 
              },
              { 
                title: 'Sound Design', 
                desc: 'Comprehensive sound effects creation, Foley recording, ambience design, and immersive audio environment building', 
                icon: '🔊' 
              },
              { 
                title: 'Audio Mixing & Mastering', 
                desc: 'Professional multi-track mixing, dialogue cleanup, music balancing, and final mastering for all distribution formats', 
                icon: '🎚️' 
              }
            ].map((service, index) => (
              <div key={index} style={{
                background: '#fff',
                padding: '30px',
                borderRadius: '15px',
                border: '2px solid #B8860B',
                textAlign: 'center',
                transition: 'transform 0.3s ease',
                boxShadow: '0 5px 20px rgba(91, 155, 213, 0.15)'
              }}>
                <div style={{ fontSize: '4rem', marginBottom: '15px' }}>{service.icon}</div>
                <h3 style={{ color: '#FFD700', marginBottom: '10px' }}>{service.title}</h3>
                <p style={{ color: '#666', lineHeight: '1.6' }}>{service.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="service-cta" style={{ 
        background: 'linear-gradient(135deg, #1a1a2e 0%, #0f3460 100%)', 
        padding: '80px 0',
        textAlign: 'center',
        color: '#fff'
      }}>
        <div className="container">
          <h2 style={{ fontSize: '2.5rem', marginBottom: '20px', color: '#FFD700' }}>Ready to Elevate Your Audio?</h2>
          <p style={{ fontSize: '1.2rem', marginBottom: '30px', color: '#87CEEB' }}>
            Let's create original music and sound design that brings your project to life
          </p>
          <button onClick={() => setIsEnquiryOpen(true)} style={{
            display: 'inline-block',
            padding: '15px 40px',
            background: 'linear-gradient(135deg, #B8860B 0%, #FFD700 100%)',
            color: '#1a1a2e',
            borderRadius: '30px',
            fontWeight: '700',
            border: 'none',
            cursor: 'pointer',
            fontSize: '1rem',
            transition: 'transform 0.3s ease'
          }}>
            Get Started
          </button>
        </div>
      </section>

      {/* Enquiry Modal */}
      <EnquiryModal 
        isOpen={isEnquiryOpen} 
        onClose={() => setIsEnquiryOpen(false)} 
        serviceName="Music Production"
      />

      {/* Footer Component */}
      <Footer />
    </div>
  );
};

export default MusicProduction;
